import * as Sentry from "@sentry/react";

export type LogEntry = {
  message: string;
  timestamp: number;
  key?: string;
};

class Logger {
  private logs: LogEntry[] = [];
  private keyedLogs: Record<string, LogEntry> = {};

  info(message: string, options?: { key?: string; publish?: boolean }): void {
    const entry: LogEntry = {
      message,
      timestamp: Date.now(),
      key: options?.key,
    };

    if (options?.key) {
      this.keyedLogs[options.key] = entry;
    } else {
      this.logs.push(entry);

      // Keep only the last 50 non-keyed log entries
      if (this.logs.length > 50) {
        this.logs = this.logs.slice(-50);
      }
    }

    if (options?.publish) {
      Sentry.logger.info(message, {
        key: options?.key,
      });

      if (!import.meta.env.PROD) {
        console.log(`[glide] ${message}`);
      }
    }
  }

  error(message: string, options?: { key?: string }): void {
    const entry: LogEntry = {
      message,
      timestamp: Date.now(),
      key: options?.key,
    };

    if (options?.key) {
      this.keyedLogs[options.key] = entry;
    } else {
      this.logs.push(entry);

      // Keep only the last 50 non-keyed log entries
      if (this.logs.length > 50) {
        this.logs = this.logs.slice(-50);
      }
    }

    Sentry.logger.error(message, {
      key: options?.key,
    });

    if (!import.meta.env.PROD) {
      console.error(`[glide] ${message}`);
    }
  }

  getLogs(): LogEntry[] {
    return [...this.logs, ...Object.values(this.keyedLogs)];
  }

  clear(): void {
    this.logs = [];
    this.keyedLogs = {};
  }
}

export const logger = new Logger();
